import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { AuthContext } from '../../shared/context/auth-context';
import { ProgrammePlayer } from '../components/ProgrammePlayer';
import { useFetchProgrammeQuery, useReEnrollProgrammeQuery } from '../mediaApiSlice';
import { setProgramme } from '../mediaSlice';

export function ProgrammePlayerWrap() {
  const auth = useContext(AuthContext);
  const dispatch = useDispatch();
  const { pathname, state } = useLocation();
  const chid = pathname.split('/')[2];

  const mediaCHID = useSelector((reduxState) => reduxState.media.programme.chid);
  const progress = useSelector((reduxState) => reduxState.media.programme.progress);

  const isEnrollmentState = state === 'enroll-programme';
  const [enrollmentComplete, setEnrollmentComplete] = useState(false);

  const { data: reEnrollData, isLoading: isEnrolling } = useReEnrollProgrammeQuery(
    { token: auth?.token, chid },
    { skip: !isEnrollmentState }
  );

  const { data: programme, isFetching } = useFetchProgrammeQuery(
    {
      token: auth.token,
      chid,
    },
    {
      skip: isEnrollmentState && !enrollmentComplete,
      refetchOnMountOrArgChange: isEnrollmentState ? true : undefined,
    }
  );

  useEffect(() => {
    if (reEnrollData) {
      setEnrollmentComplete(true);
    }
  }, [reEnrollData]);

  useEffect(() => {
    if (!isFetching && programme) {
      if (mediaCHID !== chid || progress !== programme.progress) {
        dispatch(
          setProgramme({
            _id: programme._id,
            completed: programme.completed,
            minutes_watched: programme.minutes_watched,
            days: programme.days,
            progress: programme.progress,
            related_media: programme.related_media,
            chid: programme.chid,
            title: programme.title,
            description: programme.description,
            label: programme.label,
            tags: programme.tags,
            signposting: programme.signposting,
            length: programme.length,
            author: programme.author,
            background_image: programme.background_image,
            thumbnail_image: programme.thumbnail_image,
            favourite: programme.favourite,
            like: programme.like,
            dislike: programme.dislike,
            chapters: programme.chapters,
            resources: programme.resources,
          })
        );
      }
    }
  }, [dispatch, programme, mediaCHID, progress, chid, isFetching]);

  const isLoading = isEnrolling || isFetching || (isEnrollmentState && !enrollmentComplete);

  return (
    <div id="cover-page">{isLoading ? <LoadingSpinner asOverlay /> : <ProgrammePlayer />}</div>
  );
}
